/** Header-pill model-name budget. The pill is a fixed-width chip that
 *  gives the name 70% of its width (the brand logo takes the other
 *  30%), so long catalog names have to be clipped rather than wrap or
 *  squeeze the logo. 25 characters is what fits at 14px in the 70%
 *  slot on the narrowest supported phone. */
export const MODEL_NAME_MAX_CHARS = 25

/** Hard-clips a model name to MODEL_NAME_MAX_CHARS. No ellipsis: the
 *  pill fades the label into its background instead (2026-08-21), so
 *  a trailing "…" would just be a second, redundant truncation mark.
 *  A cut landing on a space trims it. Pure. */
export function truncateModelName(
  name: string,
  maxChars: number = MODEL_NAME_MAX_CHARS,
): string {
  if (name.length <= maxChars) return name
  return name.slice(0, maxChars).trimEnd()
}
